import { fetcher } from '@commenda/utils';

export const retireBillingSku = async (skuId: string) => {
  const response = await fetcher(`commenda-billing/catalog/skus/${skuId}/retire`, {
    method: 'POST',
  });

  return response;
};
